import * as React from 'react';
import LocationDimension from './location_dimension';
import { shallow, ShallowWrapper } from 'enzyme';

import ProxyAutocomplete from '../form/location_input/proxy_autocomplete';

let wrapped: ShallowWrapper;
window.gon = {
  googleMapsApiKey: '',
  companyUserData: {},
};

describe('Location Dimension component', () => {
  beforeEach(() => {
    wrapped = shallow(
      <LocationDimension
        candidateAcceptedJobTimezone={true}
        candidateHasTimezone={false}
        value={4}
        ratingRef=''
        handleChangeLocation={jest.fn()}
        locationRef=''
        locationDefaultValue='Porto, Portugal'
        workPermitDefaultValue={true}
        handleChangeWorkPermit={jest.fn()}
        jobType='onsite_job'
        jobWithTimezone={false}
        citizenship={false}
        handleChangeTimeZone={jest.fn()}
        handleChangeTimeZoneNegative={jest.fn()}
        jobCountryNames='Brazil'
        timeZoneDefaultValue={false}
        timeZoneMismatch={false}
        timeZoneNegativeDefaultValue={false}
      />
    );
  });

  it('shallow renders without crashing', () => {
    expect(wrapped.exists()).toBe(true);
  });

  it('renders the proxy autocomplete', () => {
    expect(wrapped.find(ProxyAutocomplete).length).toEqual(1);
  });
});
